module.exports = __webpack_public_path__ + "static/img/blog-71.34608c7c.webp";